// src/utils/utils.js
import dayjs from "dayjs";

export const calculatePrices = ({ cartItems }) => {
  const itemsPrice = cartItems.reduce((acc, item) => acc + item.qty * item.price, 0);
  
  // ✅ مالیات حذف شد (همیشه صفر)
  const taxPrice = 0;
  
  const shippingPrice = itemsPrice > 100 ? 0 : 10;
  const totalPrice = itemsPrice + shippingPrice + taxPrice;

  return {
    itemsPrice: itemsPrice.toFixed(2),
    shippingPrice: shippingPrice.toFixed(2),
    taxPrice: taxPrice.toFixed(2),
    totalPrice: totalPrice.toFixed(2),
  };
};

export const beautifulDate = (date) => {
  if (!date) {
    return 'Not set';   // ✅ اگر تاریخ وجود نداشته باشد
  }
  const parsed = dayjs(date);
  if (!parsed.isValid()) {
    return 'Invalid date';   // ✅ اگر تاریخ نامعتبر باشد
  }
  return parsed.format('MMMM D, YYYY, H:MM a');
};